<template>
  <el-checkbox-group :value="value" :size="size" @input="onChange">
    <template v-for="choice in choices">
      <div :key="choice.value">
        <el-checkbox :label="choice.value" :border="border">
          {{ choice.label }}
        </el-checkbox>
      </div>
    </template>
  </el-checkbox-group>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: () => 'mini',
      validator: function (value) {
        return ['medium', 'small', 'mini'].indexOf(value) !== -1
      },
    },
    border: {
      type: Boolean,
      default: false,
    },
    choices: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    onChange(selectedItems) {
      this.$emit('input', selectedItems)
      this.$emit('change', selectedItems)
    },
  },
}
</script>
